import { Children, ReactNode } from 'react';

import { Skeleton, Stack } from '@cast/design-system';

type ChartMetricSkeletonProps = {
  height?: number;
};

const ChartMetricBlockSkeleton = ({
  height = 36,
}: ChartMetricSkeletonProps) => {
  return (
    <Skeleton
      variant="rounded"
      height={height}
      sx={{ flex: 1, minWidth: 0, width: '100%' }}
    />
  );
};

export const ChartMetricSkeleton = ({
  height,
}: ChartMetricSkeletonProps = {}) => (
  <ChartMetricBlockSkeleton height={height} />
);

type ChartMetricsRowSkeletonBaseProps = {
  alwaysRow?: boolean;
  gap?: number;
  testId?: string;
};

type ChartMetricsRowSkeletonProps = ChartMetricsRowSkeletonBaseProps &
  (
    | { count: number; children?: never }
    | { children: ReactNode; count?: never }
  );

export const ChartMetricsRowSkeleton = ({
  alwaysRow = false,
  children,
  count,
  gap = 12,
  testId,
}: ChartMetricsRowSkeletonProps) => {
  const items =
    count != null
      ? Array.from({ length: count }, (_, index) => (
          <ChartMetricSkeleton key={index} />
        ))
      : Children.toArray(children);

  return (
    <Stack
      direction={alwaysRow ? 'row' : { none: 'column', laptop: 'row' }}
      gap={gap}
      data-testid={testId}
      sx={{ '& > *': { flex: 1, minWidth: 0 } }}
    >
      {items}
    </Stack>
  );
};
